import MobileDetect from "mobile-detect";

export const getPhoneModel = () => {
  const md = new MobileDetect(window.navigator.userAgent);

  return md.phone();
};
